import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

import { assetUrl } from 'utils/url'

import type { FC } from 'react'

interface DialogPredikatKinerjaProps {
  isOpen?: boolean
  onClose?: () => void
}

const DialogPanduanPenetapanPredikatKinerja: FC<DialogPredikatKinerjaProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <>
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        type="modal"
        autoFocus={false}
        closeOnOverlayClick={false}
      >
        <DialogOverlay />
        <DialogContent>
          <DialogHeader title="Panduan Penetapan Rekomendasi Predikat Kinerja" />
          <div className="p-6">
            <div className="space-y-4">
              <Text variant="body">Berikut yang Anda dapat lakukan:</Text>

              <div className="flex items-stretch gap-2">
                <div className="p-6 border border-subdued rounded-lg flex-1">
                  <img
                    src={assetUrl('/illustrations/img-file-collaboration.png')}
                    alt=""
                    width={84}
                    height={84}
                  />

                  <Text variant="heading-sm" className="mt-4">
                    Cek Rekomendasi Predikat Kinerja
                  </Text>
                  <Text variant="body" color="subdued" className="mt-1">
                    Rekomendasi sudah otomatis terisi berdasarkan penilaian Anda
                    di tahap sebelumnya.
                  </Text>
                </div>
                <div className="flex items-center">
                  <Icon className="!cursor-default">arrow_forward</Icon>
                </div>
                <div className="p-6 border border-subdued rounded-lg flex-1">
                  <img
                    src={assetUrl('/illustrations/img-publish-data.png')}
                    alt=""
                    width={84}
                    height={84}
                  />
                  <Text variant="heading-sm" className="mt-4">
                    Kirim Rekomendasi ke Dinas Pendidikan
                  </Text>
                  <Text variant="body" color="subdued" className="mt-1">
                    Dinas Pendidikan akan memeriksa dan melanjutkan proses.
                  </Text>
                </div>
              </div>

              <div className="space-y-1">
                <Text variant="action">
                  Pelajari lebih lanjut tentang{' '}
                  <span className="text-blue-60">
                    Penetapan Predikat Kinerja
                  </span>
                </Text>
                <Text variant="body" color="subdued">
                  Berisi tentang pandangan substansi dan regulasi terkait
                  Predikat Kinerja dan sebagainya.
                </Text>
              </div>
            </div>

            <div className="border-t border-0 border-subdued pt-4 mt-6 flex justify-end">
              <Button size="lg" onClick={onClose}>
                Saya mengerti
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
export default DialogPanduanPenetapanPredikatKinerja
